<template>
  <div id="customer">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">新增功能</el-button>
    </el-row>

    <el-tabs type="border-card">
      <el-tab-pane label="表格视图">
        <el-form id="queryForm" :inline="true" :model="queryForm" class="demo-form-inline">
          <el-form-item label="功能名称">
            <el-input v-model="queryForm.name" placeholder="功能名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData.slice((queryForm.pageNum-1)*queryForm.pageSize,queryForm.pageNum*queryForm.pageSize)"
          style="width: 100%"
          :default-sort="{prop: 'date', order: 'descending'}"
          border
        >
          <el-table-column prop="name" label="显示名称"></el-table-column>
          <el-table-column prop="type" label="类型" sortable></el-table-column>
          <el-table-column prop="permission" label="权限"></el-table-column>
          <el-table-column prop="weight" label="排序"></el-table-column>
          <el-table-column prop="url" label="路由地址"></el-table-column>
          <el-table-column prop="available" label="是否可用"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                icon="el-icon-edit"
              ></el-button>
              <el-button
                size="mini"
                type="danger"
                @click="removeCustomer(scope.row)"
                icon="el-icon-delete"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="changePage"
          @size-change="changeSize"
          :current-page.sync="queryForm.pageNum"
          :page-sizes="[10,20,30,40,50]"
          :page-size="queryForm.pageSize"
          :total="tableData.length"
          layout="total,sizes, prev, pager, next"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="树型视图">
        <div class="custom-tree-container">
          <el-tree
            :data="tree"
            default-expand-all
            node-key="id"
            :props="defaultProps"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleEdit(node, data.data)"
                  icon="el-icon-edit"
                ></el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => removeCustomer(data)"
                  icon="el-icon-delete"
                ></el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="添加功能" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <el-form-item label="显示名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" :label-width="formLabelWidth">
          <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%;">
            <el-option label="顶部菜单" value="0"></el-option>
            <el-option label="左侧菜单" value="1"></el-option>
            <el-option label="按钮" value="2"></el-option>
          </el-select>
        </el-form-item>
        <MenuSelector ref="menuSelector" label="父级菜单" :label-width="formLabelWidth" />
        <el-form-item label="权限" :label-width="formLabelWidth">
          <el-input v-model="form.permission" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.weight" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" :label-width="formLabelWidth">
          <el-input v-model="form.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否可用" :label-width="formLabelWidth">
          <el-switch
            v-model="form.available"
            active-text="可用"
            inactive-text="不可用"
            inactive-value="0"
            active-value="1"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCustomer">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新功能" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-form :model="updateForm">
        <el-form-item label="显示名称" :label-width="formLabelWidth">
          <el-input v-model="updateForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" :label-width="formLabelWidth">
          <el-select v-model="updateForm.type" placeholder="请选择类型" style="width: 100%;">
            <el-option label="顶部菜单" value="0"></el-option>
            <el-option label="左侧菜单" value="1"></el-option>
            <el-option label="按钮" value="2"></el-option>
          </el-select>
        </el-form-item>
        <MenuSelector
          ref="menuSelector1"
          label="父级菜单"
          :label-width="formLabelWidth"
          :menuid="updateForm.parentId"
        />
        <el-form-item label="权限" :label-width="formLabelWidth">
          <el-input v-model="updateForm.permission" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="updateForm.weight" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" :label-width="formLabelWidth">
          <el-input v-model="updateForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否可用" :label-width="formLabelWidth">
          <el-switch
            v-model="updateForm.available"
            active-text="可用"
            inactive-text="不可用"
            inactive-value="0"
            active-value="1"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCustomer">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MenuSelector from "@/components/system/MenuSelector.vue";
export default {
  components: {
    MenuSelector
  },
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: { pageNum: 1, pageSize: 10 },
      tree: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    query() {
      var self = this;
      this.$axios
        .get("system/permission/query", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });

      this.$axios.get("system/permission/tree").then(function(response) {
        if (response.data.errorCode == "00000") {
          self.tree = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    saveCustomer() {
      this.form.parentId = this.$refs.menuSelector.selectedId;
      var self = this;
      this.$axios
        .post("system/permission/save", self.form)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.dialogFormVisible = false;
            //清空表单
            self.form = {};
            self.$message({
              message: "保存成功",
              type: "success"
            });
            self.query();
            self.$refs.menuSelector.query();
            self.$refs.menuSelector1.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    removeCustomer(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("system/permission/remove/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
                self.$refs.menuSelector.query();
                self.$refs.menuSelector1.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
      if (this.$refs.menuSelector1) {
        this.$refs.menuSelector1.selectedId = row.parentId;
      }
    },
    updateCustomer() {
      this.updateForm.parentId = this.$refs.menuSelector1.selectedId;
      var self = this;
      this.$axios
        .post("system/permission/update", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
            self.$refs.menuSelector.query();
            self.$refs.menuSelector1.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    changePage(pageNum) {
      this.queryForm.pageNum = pageNum;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
    }
  },
  created: function() {
    this.query();
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
.el-tabs {
  margin-top: 20px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>